import { render, staticRenderFns } from "./virtualexperiment.vue?vue&type=template&id=2f9e723e&scoped=true&"
import script from "./virtualexperiment.vue?vue&type=script&lang=js&"
export * from "./virtualexperiment.vue?vue&type=script&lang=js&"
import style0 from "./virtualexperiment.vue?vue&type=style&index=0&id=2f9e723e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e723e",
  null
  
)

export default component.exports